import { BillingTier } from "types/generated";

import { PLAN_FEATURES_BY_TIER } from "./constants";

const PRE_OCTOBER_2026_BUSINESS_PLAN_FEATURES = [
  { text: "Blueprints" },
  { text: "Targeted replans" },
  { text: "Templates" },
  { text: "Private provider registry" },
  { text: "Advanced scheduling" },
  { text: "Concurrent-VCS Connections", negative: true },
];

export const PRE_OCTOBER_2026_PLAN_FEATURES_BY_TIER: typeof PLAN_FEATURES_BY_TIER = {
  ...PLAN_FEATURES_BY_TIER,
  [BillingTier.V4Business]: PRE_OCTOBER_2026_BUSINESS_PLAN_FEATURES,
  [BillingTier.V5Business]: PRE_OCTOBER_2026_BUSINESS_PLAN_FEATURES,
};
